<div class="core-ui-date-filter" [class.is-open]="isOpen" [class.is-inline]="inline" [class.is-error]="error" #root>
  <div #control class="core-ui-date-filter__control" *ngIf="!inline" [class.is-filled]="isFilled"
    [class.is-readonly]="readOnly" [class.is-disabled]="disabled"
    (click)="onControlClick()" tabindex="0" [attr.aria-invalid]="error" (keydown.enter)="onControlClick()" (keydown.space)="onControlClick()">

    <div class="core-ui-date-filter__left">
      <core-ui-icon name="icon_calendar" [size]="sizeIcon" [color]="iconColor" class="core-ui-date-filter__icon"></core-ui-icon>

      <div class="core-ui-date-filter__texts">
        <span class="core-ui-date-filter__label">{{ label }}</span>

        <input *ngIf="!readOnly && !disabled"
          #textInput
          class="core-ui-date-filter__text-input"
          [class.is-placeholder]="!inputText"
          type="text"
          [placeholder]="placeholder"
          [value]="inputText"
          maxlength="10"
          autocomplete="off"
          (click)="$event.stopPropagation(); onInputClick()"
          (focus)="onInputFocus()"
          (input)="onInputChange($any($event).target.value)"
          (blur)="onInputBlur()"
          (keydown.enter)="$event.preventDefault(); onInputEnter()"
          (keydown.escape)="$event.preventDefault(); onInputEscape()"
        />

        <span *ngIf="readOnly || disabled"
          class="core-ui-date-filter__value"
          [class.is-placeholder]="isPlaceholder"
          [class.is-filled-text]="isFilled">
          {{ displayValue }}
        </span>
      </div>
    </div>

    <div class="core-ui-date-filter__actions" *ngIf="showClearButton || !hideChevron">
      <button
        *ngIf="showClearButton"
        type="button"
        class="core-ui-date-filter__clear"
        aria-label="Limpiar fecha"
        (mousedown)="$event.preventDefault(); $event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
        (click)="clearValue($event)"
      >
        <core-ui-icon name="icon_close" size="12"></core-ui-icon>
      </button>

      <div class="core-ui-date-filter__chevron" *ngIf="!hideChevron">
        <core-ui-icon name="chevron" [direction]="isOpen ? 'up' : 'down'" [color]="'#5F7081'"
          [extraClass]="'klab-sidebar__item-chevron'">
        </core-ui-icon>
      </div>
    </div>
  </div>

  <div *ngIf="isOpen || inline" #dropdown class="core-ui-date-filter__dropdown core-ui-date-filter__dropdown--calendar" [class.is-inline-dropdown]="inline"
    [ngStyle]="dropdownStyle">
    <div class="kd-calendar">
      <div class="kd-calendar__header">
        <button type="button" class="kd-calendar__nav-btn" *ngIf="viewMode === 'days'" (click)="onPrevMonth()">
          <core-ui-icon name="chevron" [direction]="'left'"></core-ui-icon>
        </button>
        <button type="button" class="kd-calendar__nav-btn" *ngIf="viewMode === 'months'" (click)="onPrevMonthYear()">
          <core-ui-icon name="chevron" [direction]="'left'"></core-ui-icon>
        </button>
        <button type="button" class="kd-calendar__nav-btn" *ngIf="viewMode === 'years'" (click)="onPrevYearPage()">
          <core-ui-icon name="chevron" [direction]="'left'"></core-ui-icon>
        </button>

        <span class="kd-calendar__month-label kd-calendar__month-label--clickable" (click)="toggleYearPicker()">
          <ng-container *ngIf="viewMode === 'days'">{{ monthLabel }}</ng-container>
          <ng-container *ngIf="viewMode === 'months'">{{ currentMonth.getFullYear() }}</ng-container>
          <ng-container *ngIf="viewMode === 'years'">{{ yearRangeLabel }}</ng-container>
        </span>

        <button type="button" class="kd-calendar__nav-btn" *ngIf="viewMode === 'days'" (click)="onNextMonth()">
          <core-ui-icon name="chevron" [direction]="'right'"></core-ui-icon>
        </button>
        <button type="button" class="kd-calendar__nav-btn" *ngIf="viewMode === 'months'" (click)="onNextMonthYear()">
          <core-ui-icon name="chevron" [direction]="'right'"></core-ui-icon>
        </button>
        <button type="button" class="kd-calendar__nav-btn" *ngIf="viewMode === 'years'" (click)="onNextYearPage()">
          <core-ui-icon name="chevron" [direction]="'right'"></core-ui-icon>
        </button>
      </div>

      <ng-container *ngIf="viewMode === 'days'">
        <div class="kd-calendar__weekdays">
          <span *ngFor="let wd of weekDays">{{ wd }}</span>
        </div>

        <div class="kd-calendar__grid">
          <button type="button" class="kd-calendar__day" *ngFor="let day of monthDays"
            [class.is-outside]="day.isOutside"
            [class.is-selected]="isActiveDay(day.date) || isDayHighlighted(day.date)"
            [class.is-disabled]="isDayDisabled(day)"
            [disabled]="isDayDisabled(day)"
            (click)="onSelectDay(day)">
            <span class="kd-calendar__day-inner">{{ day.label }}</span>
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="viewMode === 'months'">
        <div class="kd-month-picker">
          <button *ngFor="let m of monthList" type="button"
            class="kd-month-picker__month"
            [class.is-selected]="m.value === currentMonth.getMonth()"
            (click)="onSelectMonth(m.value)">
            {{ m.label }}
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="viewMode === 'years'">
        <div class="kd-year-picker">
          <button *ngFor="let yr of yearList" type="button"
            class="kd-year-picker__year"
            [class.is-selected]="yr === currentMonth.getFullYear()"
            (click)="onSelectYear(yr)">
            {{ yr }}
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
